<template>
  <div id="invoice-page">
    <div>
      <div class="container-fluid p-2">
        <div class="vx-row">
          <div class="vx-col sm:w-1/1 w-full mb-2">
            <vx-card>
              <form role="form" @submit.stop.prevent="buscar">
                <div class="vx-row">
                  <div class="vx-col sm:w-1/5 w-full">
                    <span>ID</span>
                    <vs-input class="w-full" name="id" id="id" v-model="formFiltro.idEncomenda"
                      :state="validateState('id')" :danger="validateClass('id')" val-icon-danger="clear"
                      danger-text="Preencha este Campo" />
                  </div>
                  <div class="vx-col sm:w-1/5 w-full">
                    <span>Nome</span>
                    <vs-input class="w-full" name="Nome" id="Nome" v-model="formFiltro.nome"
                      :state="validateState('Nome')" :danger="validateClass('Nome')" val-icon-danger="clear"
                      danger-text="Preencha este Campo" />
                  </div>
                  <div class="vx-col sm:w-1/5 w-full">
                    <span>CPF</span>
                    <vs-input v-mask="'##############'" class="w-full" name="Cpf Cnpj" id="Cpf Cnpj"
                      v-model="formFiltro.cpf" :state="validateState('Cpf Cnpj')" :danger="validateClass('Cpf Cnpj')"
                      val-icon-danger="clear" danger-text="Preencha este Campo" />
                  </div>
                  <div class="vx-col sm:w-1/5 w-full">
                    <span>Email</span>
                    <vs-input class="w-full" name="Email" id="Email" v-model="formFiltro.email"
                      :state="validateState('Email')" :danger="validateClass('Email')" val-icon-danger="clear"
                      danger-text="Preencha este Campo" />
                  </div>
                  <div class="vx-col sm:w-1/5 w-full">
                    <span>Celular</span>
                    <vs-input v-mask="'(##) #####-####'" class="w-full" name="celular" id="celular"
                      v-model="formFiltro.celular" :state="validateState('celular')" :danger="validateClass('celular')"
                      val-icon-danger="clear" danger-text="Preencha este Campo" />
                  </div>
                  <div class="vx-col sm:w-1/5 w-full">
                    <span>Status</span>
                    <v-select :options="statusEncomenda" name="Status" id="Status" v-model="formFiltro.idStatus"
                      multiple></v-select>
                  </div>
                  <div class="vx-col sm:w-1/5 w-full">
                    <span>Tags</span>
                    <v-select :options="tagsEncomenda" name="Tags" id="Tags" v-model="formFiltro.idTag"
                      multiple></v-select>
                  </div>
                  <div class="vx-col sm:w-1/5 w-full">
                    <span>Estado</span>
                    <v-select :options="estados" name="Estado" id="Estado" v-model="estado"
                      @selected="buscaDadosSelectsCidades"></v-select>
                  </div>

                  <!-- Cidade -->
                  <div class="vx-col sm:w-1/5 w-full">
                    <span>Cidade</span>
                    <v-select :options="cidades" name="Cidade" id="Cidade" v-model="formFiltro.cidade"></v-select>
                  </div>

                  <div class="vx-col sm:w-1/5 w-full">
                    <span>Empresas</span>
                    <v-select :options="empresas" name="Empresa" id="Empresa" v-model="formFiltro.empresas"
                      multiple></v-select>
                  </div>
                  <div class="vx-col sm:w-1/5 w-full mt-6 flex items-center gap-2">
                    <vs-button type="gradient" type-button="submit">
                      <vs-icon icon-pack="feather" icon="icon-search" /> Pesquisar
                    </vs-button>

                    <downloadexcel :data="itens" :fields="colunasArq" name="Encomendas.xls" type="xls" class="btn-xls">
                      <vs-icon icon-pack="feather" icon="icon-download" /> Exportar
                    </downloadexcel>
                  </div>
                </div>
              </form>
            </vx-card>
          </div>
        </div>
      </div>
      <!-- inicio lista de associados -->
      <div v-if="itens.length > 0" class="container-fluid p-2 mb-6">
        <div :class="`vx-row `">
          <div class="vx-col sm:w-1/2 w-full">
            <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
              <div
                class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                <span class="mr-2">{{ paginaAtual * itemsPerPage - (itemsPerPage - 1) }} -
                  {{
                    itens.length - paginaAtual * itemsPerPage > 0
                      ? paginaAtual * itemsPerPage
                      : itens.length
                  }}
                  de {{ qtdTotal }} Encomendas</span>
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>
              <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
              <vs-dropdown-menu>
                <vs-dropdown-item @click="itemsPerPage = 25">
                  <span>25</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage = 50">
                  <span>50</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage = 100">
                  <span>100</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage = 300">
                  <span>300</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage = 1000">
                  <span>1000</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage = 5000">
                  <span>5000</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage = 10000">
                  <span>10000</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>
        </div>

        <vx-card>
          <vs-table noDataText="Nenhuma Encomenda Encontrado" class="tablePrincipal table-bordered" ref="table"
            :data="itens">
            <template slot="thead">
              <vs-th sort-key="idEncomenda">Encomenda</vs-th>
              <vs-th sort-key="nomeEmpresa">Empresa</vs-th>
              <vs-th sort-key="nome">Cliente</vs-th>
              <vs-th sort-key="Usuario">Itens</vs-th>
              <vs-th sort-key="Usuario">Valor Pix Creditado</vs-th>
              <vs-th sort-key="Status">Status</vs-th>
              <vs-th sort-key="Status">Tags</vs-th>
              <vs-th sort-key="Status">Frete</vs-th>
              <vs-th>Ações</vs-th>
            </template>

            <template slot-scope="{ data }">
              <tbody>
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td>
                    <p class="product-category">
                      {{ tr.idEncomenda }}<br />
                      {{ formataData(tr.createdAt) }}
                    </p>
                  </vs-td>
                  <vs-td>
                    <p class="product-category">
                      {{ tr.nomeEmpresa }}
                    </p>
                  </vs-td>
                  <vs-td>
                    <p class="product-category">
                      {{ tr.nome }}
                      <br />
                      {{ tr.cpf }}
                      <br />
                      {{ tr.email }}
                      <br />
                      {{ tr.celular }}
                    </p>
                    <h6 class="endereco">Endereço: </h6>
                    <p class="product-category">
                      {{ tr.endereco }},{{ tr.numero }} {{ tr.complemento }}
                      <br />
                      {{ tr.bairro }} <br />
                      {{ tr.cidade }} / {{ tr.estado }} <br />
                      {{ tr.cep }}
                    </p>
                    <h6 class="endereco">Código de Rastreio: </h6>
                    <p class="product-category">
                      <span v-if="!tr.codigoRastreio">Não foi gerado</span>
                      <span v-else>{{ tr.codigoRastreio }}</span>
                    </p>
                  </vs-td>
                  <vs-td>
                    <p class="product-category" v-for="item in tr.itens" :key="item.idItem">
                      <a href="javascript:void(0)" @click="detalhe(item)">{{ item.qtd }} - {{ item.nomeItem }} ({{
                        item.nomeCaixa
                      }}) (SKU {{ item.sku }})
                      </a>
                    </p>
                  </vs-td>
                  <vs-td>
                    <p>{{ tr.valorPix | currency }}</p>
                  </vs-td>
                  <vs-td>
                    <v-select v-if="tr.edit == true" :options="statusEncomenda" name="Status" id="Status"
                      v-model="tr.status" append-to-body></v-select>
                    <vs-chip v-else :color="getStatusColor(tr.idStatus)" class="product-order-status">{{ tr.nomeStatus
                    }}</vs-chip>
                  </vs-td>

                  <vs-td>
                    <v-select v-if="tr.edit == true" :options="tagsEncomenda" name="Tags" id="Tags" v-model="tr.tagsAux"
                      :reduce="(t) => t.id" multiple append-to-body></v-select>
                    <div v-else>
                      <vs-chip v-for="chip in tr.tags" :key="chip.idTag" color="dark">{{ chip.descricao }}</vs-chip>
                    </div>
                  </vs-td>

                  <vs-td>
                    <p v-if="tr.edit == false">
                      <vs-chip color="success" v-if="tr.idUsuarioFrete">Frete grátis</vs-chip>
                      <span v-else> {{ tr.valorFrete | currency }}</span>
                    </p>
                    <div v-else>
                      <money v-if="!tr.idUsuarioFrete" class="w-full vs-inputx vs-input--input large" name="Valor"
                        id="Valor" v-model="tr.valorFrete" v-bind="money"></money>
                      <vs-chip color="success" v-else>Frete grátis</vs-chip>
                    </div>
                  </vs-td>

                  <vs-td>
                    <div class="vx-row">
                      <div class="vx-col text-center" v-if="tr.edit == true">
                        <div @click="atualiza(tr)" class="rounded-full cursor-pointer bg-success">
                          <vs-icon round class="m-1" size="medium" color="white" icon="check"></vs-icon>
                        </div>
                      </div>
                      <div class="vx-col text-center" v-if="tr.edit == true">
                        <div @click="tr.edit = false" class="rounded-full cursor-pointer bg-danger">
                          <vs-icon round class="m-1" size="medium" color="white" icon="clear"></vs-icon>
                        </div>
                      </div>
                      <div class="vx-col text-center">
                        <div class="dropdownAcoes mr-2">
                          <vs-dropdown vs-trigger-click class="flex cursor-pointer">
                            <div class="rounded-full cursor-pointer" style="background: #078fcf">
                              <vs-icon round class="m-1" size="medium" color="white" icon="more_horiz"></vs-icon>
                            </div>
                            <vs-dropdown-menu style="width: 250px">
                              <vs-dropdown-item
                                v-if="(tr.idStatus !== 3 && tr.idStatus !== 4) && $can('afiliados', 'edit')"
                                @click="tr.edit = true">
                                <div class="flex gap-3">
                                  <vs-icon color="success" icon-pack="feather" icon="icon-edit">
                                  </vs-icon>
                                  <span>Editar Dados</span>
                                </div>
                              </vs-dropdown-item>

                              <vs-dropdown-item divider target="_blank" class="pt-2"
                                :to="`detalheEncomenda/${tr.idEncomenda}`">
                                <div class="flex gap-3">
                                  <vs-icon color="primary" icon-pack="feather" icon="icon-search">
                                  </vs-icon>
                                  <span>Ver detalhes da Encomenda</span>
                                </div>
                              </vs-dropdown-item>
                            </vs-dropdown-menu>
                          </vs-dropdown>
                        </div>
                      </div>
                    </div>
                  </vs-td>
                </vs-tr>
              </tbody>
            </template>
          </vs-table>

          <vs-pagination :total="qtdPaginas" v-model="paginaAtual"></vs-pagination>
        </vx-card>
        <vs-popup class="holamundo" :title="'Detalhe'" :active.sync="modalImagem" @close="modalImagem = false">
          <img :src="imagemModal" width="100%" style="max-width: 450px" />
          <p>
            <b>SKU:</b> {{ dadosItem.sku }} <br /><br />
            <b>Altura:</b> {{ dadosItem.altura }} cm <br />
            <b>Largura:</b> {{ dadosItem.largura }} cm<br />
            <b>Comprimento:</b> {{ dadosItem.comprimento }} cm<br />
            <b>Peso:</b> {{ dadosItem.pesoGramas }} gramas
          </p>
          <table class="table table-bordered" v-if="
            dadosItem &&
            dadosItem.variacoesSelecionadas &&
            dadosItem.variacoesSelecionadas.length > 0
          ">
            <thead>
              <tr>
                <th>Variação</th>
                <th>Valor</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in dadosItem.variacoesSelecionadas" :key="item.idItem">
                <td>{{ item.variacao }}</td>
                <td>{{ item.valorSelecionado }}</td>
              </tr>
            </tbody>
          </table>
        </vs-popup>
      </div>
      <div v-else class="text-center">Nenhuma Encomenda Encontrada</div>
      <!-- fim da lista de associados -->
    </div>
  </div>
</template>

<script>
import service from "../../services";
import moment from "moment";
import jwt from "jsonwebtoken";
import vSelect from "vue-select";
import locale from "../../locale";
import VueJsonPretty from "vue-json-pretty";
import { Money } from "v-money";
import downloadexcel from "vue-json-excel";

import "vue-json-pretty/lib/styles.css";
export default {
  watch: {
    realizaFiltro: function (newValue) {
      if (newValue == true) {
        this.buscar();
        this.$emit("filtroOk", true);
      }
    },
    paginaAtual: function () {
      this.buscar();
    },
    itemsPerPage: function () {
      this.buscar();
    },
    estado(value) {
      this.formFiltro.estado = value;
      this.formFiltro.cidade = null;
      this.buscaDadosSelectsCidades(
        "domMunicipios",
        "cidades",
        "nomeCidade",
        "idCidade"
      );
    },
  },
  data() {
    return {
      decoded: null,
      popupDependenteActive: false,
      dadosDependente: null,
      desabilitarFiltroDependente: false,
      desabilitarOutrosFiltros: false,
      dependentesItens: [],
      formStatus: {},
      formFiltro: {
        cidade: null,
        empresas: null,
        email: "",
        idStatus: [
          { id: 1, label: "Em Aberto" },
        ],
      },
      money: {
        decimal: ".",
        thousands: "",
        prefix: "",
        suffix: "",
        precision: 2,
      },
      senha: null,
      status: [],
      logs: [],
      estados: [],
      cidades: [],
      empresas: [],
      colunas: [
        "idEncomenda",
        "createdAt",
        "nomeEmpresa",
        "chave",
        "valorFrete",
        "valorPix",
        "codigoRastreio",
        "nome",
        "cpf",
        "email",
        "celular",
        "endereco",
        "numero",
        "complemento",
        "bairro",
        "cidade",
        "estado",
        "cep",
        "nomeStatus",
        "itensEncomenda",
        "tagsEncomenda",
      ],
      colunasArq: {},
      estado: null,
      popupActive: false,
      dadosAssociado: null,
      selected: [],
      itens: [],
      itemsPerPage: 25,
      paginaAtual: 1,
      qtdTotal: 0,
      qtdPaginas: 0,
      statusEncomenda: [],
      tagsEncomenda: [],
      isMounted: false,
      modalImagem: false,
      imagemModal: "",
      dadosItem: {},
      acao: ["Inativar", "Reativar"],
      logo: "https://box-da-sorte.s3.amazonaws.com/titulo-email.png",
    };
  },
  methods: {
    detalhe(dados) {
      console.log(dados);
      this.modalImagem = true;
      this.imagemModal = dados.imagem;
      this.dadosItem = dados;
    },
    formataData(data) {
      return moment(data).format("DD/MM/YYYY HH:mm");
    },
    getStatusColor(data) {
      if (data == 3) return "success";
      if (data == 1) return "warning";
      if (data == 2) return "primary";
      return "danger";
    },
    getStatusString(data) {
      if (data == null) return "Prospect";
      return data;
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    atualiza(tr) {
      console.log(tr);

      this.$vs.loading();
      service
        .post("Externo", "AtualizarEncomenda", tr)
        .then(() => {
          tr.edit = false;
          this.$vs.loading.close();
          this.buscar();
        })
        .catch((e) => {
          this.$vs.notify({
            position: "top-center",
            title: "Atenção",
            text: e,
            color: "danger",
          });
          this.$vs.loading.close();
        });
    },
    buscarDetalhe(item) {
      this.$vs.loading();
      var objSend = {};
      objSend.idAssociado = item.id_prospect;
      objSend.idEmpresa = item.id_empresa;
      service
        .post("Externo", "DetalheAssociado", objSend)
        .then((res) => {
          var aux = res.data;
          var propostas = [];
          var veiculos = [];
          var dependentes = [];

          if (aux.propostas) propostas = JSON.parse(res.data.propostas);
          if (aux.veiculos) veiculos = JSON.parse(res.data.veiculos);
          if (aux.dependentes) dependentes = JSON.parse(res.data.dependentes);

          this.dadosAssociado = res.data;
          delete this.dadosAssociado.boletos;
          delete this.dadosAssociado.propostas;
          delete this.dadosAssociado.veiculos;
          delete this.dadosAssociado.registrosFinanceiros;
          delete this.dadosAssociado.dependentes;

          this.dadosAssociado.propostas = propostas;
          this.dadosAssociado.veiculos = veiculos;
          this.dadosAssociado.dependentes = dependentes;

          this.popupActive = true;
          this.$vs.loading.close();
          this.$forceUpdate();
        })
        .catch((e) => {
          this.error = true;
          this.$vs.notify({
            position: "top-center",
            title: "Atenção",
            text: e,
            color: "danger",
          });
          this.$vs.loading.close();
        });
    },
    buscar() {
      var objSend = {};
      if (this.formFiltro) {
        objSend = { ...this.formFiltro };
      }

      console.log(objSend);

      objSend.pagina = this.paginaAtual;
      objSend.qtdPorPagina = this.itemsPerPage;
      objSend.idEmpresa = 0;

      this.$vs.loading();

      service
        .post("Externo", "listarEncomendas", objSend)
        .then((res) => {
          this.exibir = true;
          this.itens = [];
          console.log("682 res.data", res.data);
          this.qtdTotal = res.data.qtd;
          this.qtdPaginas = this.qtdTotal / this.itemsPerPage;

          if (this.qtdPaginas % 1 != 0) this.qtdPaginas++;
          this.qtdPaginas = parseInt(this.qtdPaginas);

          if (this.qtdTotal > 0) {
            res.data.encomendas.forEach((element) => {
              element.itens = JSON.parse(element.itens);
              element.itens.forEach((el) => {
                el.variacoesSelecionadas = el.variacoesSelecionadas
                  ? JSON.parse(el.variacoesSelecionadas)
                  : [];
              });
              element.relacionamentos = JSON.parse(element.relacionamentos);
              element.tags = JSON.parse(element.tags);
              element.edit = false;
              element.status = {
                id: element.idStatus,
                label: element.nomeStatus,
              };

              if (element.tags && element.tags.length > 0) {
                element.tagsAux = [];
                element.tags.forEach((el) => {
                  element.tagsAux.push(el.idTag);
                });
              }
              this.itens.push(element);

              this.colunas.forEach((el) => {
                this.colunasArq[el] = el;
              });
            });
          }

          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.notify({
            position: "top-center",
            title: "Atenção",
            text: e,
            color: "danger",
          });
          this.$vs.loading.close();
        });
    },
    habilitaDesabilitaFiltros(value) {
      const inputHabilitado = value.length > 0 ? true : false;
      return inputHabilitado;
    },
    verificaOutrosFiltros(verificarOutrosFiltros) {
      const numCaracCpfCnpj = this.formFiltro.hasOwnProperty("cpfCnpj")
        ? this.formFiltro.cpfCnpj.length
        : 0;

      const numCaracPlaca = this.formFiltro.hasOwnProperty("placa")
        ? this.formFiltro.placa.length
        : 0;

      const numCaracChassi = this.formFiltro.hasOwnProperty("chassi")
        ? this.formFiltro.chassi.length
        : 0;

      if (verificarOutrosFiltros === false) {
        this.desabilitarFiltroDependente =
          numCaracCpfCnpj > 0 || numCaracPlaca > 0 || numCaracChassi > 0
            ? true
            : false;
      }
    },

    desabilitarCursoMouse(status) {
      const classeCssDesabilitarMouse = "desabilitaMouse";
      if (status) return classeCssDesabilitarMouse;
    },
    verificaDecoded() {
      const token = localStorage.getItem("user-token");

      if (token) {
        this.decoded = jwt.decode(token);
      }
    },
    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service.getAll("g", {}, `${model}/list`).then((res) => {
        const result = res.data.sort((a, b) =>
          a[campoDescricao] > b[campoDescricao] ? 1 : -1
        );

        result.forEach((element) => {
          if (element.deletedAt == null)
            this[array].push({
              id: element[campoPK],
              label: element[campoDescricao],
            });
        });
      });
    },
    buscaDadosSelectsCidades(model, array, campoDescricao, campoPK) {
      if (this.formFiltro.estado) {
        this.$vs.loading();
        this[array] = [];
        service
          .getAll("g", {}, `${model}/list/idUf/${this.formFiltro.estado.id}`)
          .then((res) => {
            res.data.forEach((element) => {
              this[array].push({
                id: element[campoPK],
                label: element[campoDescricao],
              });
            });

            this.$vs.loading.close();
          });
      }
    },
  },
  mounted() {
    this.buscaDadosSelects(
      "domStatusEncomendas",
      "statusEncomenda",
      "nomeStatus",
      "idStatus"
    );
    this.buscaDadosSelects(
      "domTagsEncomenda",
      "tagsEncomenda",
      "descricao",
      "idTag"
    );

    this.buscaDadosSelects("empresas", "empresas", "nomeEmpresa", "idEmpresa");

    this.buscaDadosSelects("domUf", "estados", "nomeUf", "idUf");

    this.$validator.localize("ptBr", locale);
    this.buscar();
    this.verificaDecoded();
  },
  components: {
    "v-select": vSelect,
    VueJsonPretty,
    Money,
    downloadexcel,
  },
};
</script>
<style scoped lang="scss">
.desabilitaMouse {
  cursor: not-allowed;
}

.endereco {
  font-weight: 600;
  font-size: 13px;
  color: #626262;
  margin-top: 10px;
}

.btn-xls {
  margin-left: 9px;
  background-color: #ff4e08;
  color: #efefef;
  border-radius: 8px;
  padding: 10px;
  cursor: pointer;

  &:hover {
    background-color: #c2572c;
  }
}

.table-bordered {
  display: table;
  border-collapse: separate;
  box-sizing: border-box;
  border-spacing: 2px;
  border-color: grey;
  width: 100%;
  border: 1px solid gray;

  tr td {
    padding: 2px;
    padding-top: 5px;
    vertical-align: top;
  }

  tr:nth-child(2n) {
    background: #efefef !important;
  }
}

.vdp-datepicker input {
  width: 100%;
}
</style>
<style>
.vs__dropdown-menu {
  min-width: 275px;
}
</style>
